import React from "react";

function UserCheck01({ fill, ...restProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill={fill ?? ""}
      viewBox="0 0 24 24"
      {...restProps}
    >
      <path
        d="M9.365 2.046c-1.759.184-3.366 1.289-4.24 2.917-.703 1.309-.809 2.994-.28 4.444.558 1.53 1.852 2.781 3.42 3.306a5.47 5.47 0 0 0 5.51-1.232c1.018-.978 1.591-2.172 1.7-3.547.132-1.661-.466-3.226-1.68-4.395-1.184-1.141-2.751-1.669-4.43-1.493M10.9 4.117c.935.241 1.772.928 2.22 1.823.293.585.34.797.34 1.56s-.047.976-.34 1.56a3.507 3.507 0 0 1-2.14 1.804c-.326.1-.418.11-.98.11-.561 0-.654-.01-.98-.109a3.58 3.58 0 0 1-2.409-2.468c-.054-.196-.071-.408-.071-.897 0-.692.042-.929.249-1.397.385-.874 1.212-1.636 2.085-1.922a3.91 3.91 0 0 1 2.026-.064M5.54 14.546c-.814.097-1.216.21-1.808.509-.49.247-.891.54-1.29.944a4.898 4.898 0 0 0-1.35 2.596c-.052.297-.068.652-.07 1.548l-.002 1.163.121.197a.998.998 0 0 0 1.718 0l.121-.197.026-1.103c.031-1.263.071-1.527.31-2.018a2.959 2.959 0 0 1 1.354-1.36c.585-.294.371-.279 4.15-.303 3.161-.02 3.411-.027 3.56-.094.356-.16.619-.555.619-.928 0-.245-.135-.549-.324-.728-.279-.265-.092-.253-3.724-.246-1.81.003-3.345.012-3.411.02m16.1.522c-.152.053-.444.326-1.909 1.785l-1.729 1.722-.731-.72c-.616-.608-.762-.732-.928-.788a1 1 0 0 0-1.215.449c-.092.156-.108.229-.107.484 0 .213.022.341.074.44.102.193 2.202 2.3 2.425 2.433.153.091.225.107.48.106.212 0 .341-.022.44-.074.192-.1 4.299-4.2 4.433-4.425.091-.152.107-.226.107-.48s-.017-.328-.108-.484a1.016 1.016 0 0 0-1.232-.448"
        fill-rule="evenodd"
        fill={fill ?? ""}
      />
    </svg>
  );
}

export default UserCheck01;
